import {
  resolvePicSrc,
  isLegacyPicPath,
  isCustomImageSrc,
} from "./branch-images.js";

export { isLegacyPicPath, isCustomImageSrc };

function isParcelHashedSrc(value) {
  return /^(?:\/|\.\/)?[^/]+\.[a-f0-9]{6,}\.(jpe?g|png|webp|gif|svg)$/i.test(value);
}

function basenameFromImageSrc(value) {
  const match = String(value).match(/\/([^/?#]+?)(?:\.[a-f0-9]{6,})?(?:\.(jpe?g|png|webp|gif|svg))(?:[?#]|$)/i);
  return match?.[1] ?? "";
}

/** Keep Parcel-bundled src; only override for uploads / external URLs. */
export function resolveImageSrc(value, el) {
  if (!value?.trim()) return null;

  if (isCustomImageSrc(value)) return value;

  const current = el?.getAttribute("src") ?? "";

  if (isLegacyPicPath(value)) {
    if (current && !isLegacyPicPath(current)) return null;
    return resolvePicSrc(value);
  }

  if (isParcelHashedSrc(value) && current && current !== value) {
    const storedBase = basenameFromImageSrc(value);
    const currentBase = basenameFromImageSrc(current);
    if (storedBase && currentBase && storedBase === currentBase) return null;
  }

  return value;
}

export function shouldPersistImage(value, defaultValue) {
  if (!value?.trim()) return false;
  if (value === defaultValue) return false;
  if (isLegacyPicPath(value) && isLegacyPicPath(defaultValue)) return false;
  return true;
}
